import React from "react";
import { useTimelineReveal } from "./hooks/useTimelineReveal";

interface TimelineItemProps {
  item: {
    id: string;
    date?: string;
    title: string;
    description?: string;
  };
  index: number;
}

export const TimelineItem: React.FC<TimelineItemProps> = ({ item, index }) => {
  const { ref, visible } = useTimelineReveal();
  const isLeft = index % 2 === 0;

  return (
    <div
      ref={ref}
      className={`relative w-full px-10 py-6 md:w-1/2 md:px-12 transition-all duration-[600ms] ease-[cubic-bezier(0.16,1,0.3,1)]
      ${visible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}
      ${isLeft
          ? "md:left-0 md:pr-12 md:text-right"
          : "md:left-1/2 md:pl-12 md:text-left"
        }`}
    >
      {/* Dot on the line */}
      <div
        className={`absolute top-1/2 h-2.5 w-2.5 -translate-y-1/2 border-[1.5px] border-muted-foreground/40 bg-background z-10 rounded-full
        ${isLeft
            ? "left-[30px] md:left-auto md:right-[-5px]"
            : "left-[30px] md:left-[-5px]"
          }`}
      />

      {/* Card */}
      <div className="inline-block w-full max-w-[420px] overflow-hidden rounded-xl border border-border bg-card px-7 py-6 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:scale-[1.01] hover:shadow-md">
        {item.date && (
          <span className="mb-2 inline-block text-xs font-medium tracking-wider text-muted-foreground">
            {item.date}
          </span>
        )}
        <h3 className="mb-3 text-lg font-semibold leading-tight tracking-tight text-foreground text-center">
          {item.title}
        </h3>
        {item.description && (
          <p className="text-sm leading-relaxed text-muted-foreground text-center">
            {item.description}
          </p>
        )}
      </div>
    </div>
  );
};
